import React from 'react';
export const CTAButton = () => {
  return <a href="https://www.tryglisera.com/products/glisera%E2%84%A2-copper-renewal-serum" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg shadow-md transition-all transform hover:scale-105 w-full md:w-auto md:min-w-[300px] uppercase tracking-wider inline-block text-center" data-id="element-260">
      CLAIM YOUR 40% DISCOUNT NOW →
    </a>;
};